import { Form } from '@factorialco/deprecated-design-system'
import {
  BreakConfigurationFragment,
  TimePlanningPlannedBreakBreakTypeEnum as BreakType,
} from 'generated/resources/graphql'

import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'
import FixedPeriodForm from 'modules/work_schedules/components/FixedPeriodForm'
import FlexiblePeriodForm from 'modules/work_schedules/components/FlexiblePeriodForm'
import WarningModal from 'modules/work_schedules/components/WarningModal'
import { DayConfigurationWithBreaksForm } from 'modules/work_schedules/hooks/useDayConfigurations'
import type DayConfigurationForm from 'modules/work_schedules/lib/forms/DayConfigurationForm'
import type WorkSchedulePeriodForm from 'modules/work_schedules/lib/forms/WorkSchedulePeriodForm'
import type WorkSchedule from 'modules/work_schedules/store/models/Schedule'

interface Props {
  onSubmit: () => void
  periodFormRef: WorkSchedulePeriodForm
  dayConfigForms: DayConfigurationWithBreaksForm[]
  totalHours: number
  onAddDayConfig: (weekday: string) => void
  onAddBreak: (
    breakConfiguration: BreakConfigurationFragment,
    breakType: BreakType,
    dayConfiguration: DayConfigurationWithBreaksForm
  ) => void
  onDeleteBreak: (dayConfiguration: DayConfigurationWithBreaksForm, form: PlannedBreakForm) => void
  onDeleteDayConfig: (dayConfigForm: DayConfigurationForm) => void
  onCopyFirstToAll: () => void
  disabled: boolean
  openWarning: boolean
  confirm: () => void
  workSchedule: WorkSchedule
  onClose: () => void
  canEdit: boolean
  canReassignAll: boolean
  canAssignEmployees: boolean
  canAddBreaks: boolean
}

const WorkScheduleFormComponent = ({
  onSubmit,
  periodFormRef,
  dayConfigForms,
  totalHours,
  onAddDayConfig,
  onAddBreak,
  onDeleteBreak,
  onDeleteDayConfig,
  onCopyFirstToAll,
  disabled,
  openWarning,
  confirm,
  onClose,
  workSchedule,
  canEdit,
  canReassignAll,
  canAssignEmployees,
  canAddBreaks,
}: Props) => {
  const disabledButtonModal = disabled || !canEdit
  const commonProps = {
    onSubmit,
    periodFormRef,
    dayConfigForms,
    totalHours,
    onCopyFirstToAll,
    onAddBreak,
    onDeleteBreak,
    disabled,
    canAddBreaks,
  }

  return (
    <Form withBackground>
      {periodFormRef.isFixed ? (
        <FixedPeriodForm
          {...commonProps}
          onAddDayConfig={onAddDayConfig}
          onDeleteDayConfig={onDeleteDayConfig}
        />
      ) : (
        <FlexiblePeriodForm {...commonProps} />
      )}
      {openWarning && (
        <WarningModal
          onSubmit={onSubmit}
          onConfirm={confirm}
          onClose={onClose}
          workSchedule={workSchedule}
          disabled={disabledButtonModal}
          canReassignAll={canReassignAll}
          canAssignEmployees={canAssignEmployees}
        />
      )}
    </Form>
  )
}

export default WorkScheduleFormComponent
